import React, { useRef } from "react";
import { bool, func, string } from "prop-types";
import { useTranslation } from "@lib/i18n";

import { Button } from "./Button";
import Typography from "./Typography";
import SimpleButton from "./SimpleButton";
import Modal from "./Modal";

const CEEUnavailableModal = ({ isOpen, onConfirm, onCancel, dataId }) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);
  const modalLastElement = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      ariaLabel={t("ceeSubsidyUnavailableModal.heading")}
      firstElement={modalFirstElement}
      lastElement={modalLastElement}
      onClose={onCancel}
    >
      <div
        className="flex flex-col items-center h-full gap-8 py-4 text-center"
        data-id={`${dataId}-modal-container`}
      >
        <h4 className="text-xl font-semibold">
          {t("ceeSubsidyUnavailableModal.heading")}
        </h4>
        <Typography>{t("ceeSubsidyUnavailableModal.description")}</Typography>
        <div className="flex flex-wrap items-center justify-center gap-4 w-full">
          <Button
            ref={modalFirstElement}
            onClick={onCancel}
            data-id={`${dataId}-change-cancel-btn`}
          >
            {t("ceeSubsidyUnavailableModal.stay")}
          </Button>
          <SimpleButton
            ref={modalLastElement}
            onClick={onConfirm}
            dataId={`${dataId}-change-confirm-btn`}
            className="m-0 p-4"
          >
            {t("ceeSubsidyUnavailableModal.continue")}
          </SimpleButton>
        </div>
      </div>
    </Modal>
  );
};

CEEUnavailableModal.propTypes = {
  isOpen: bool.isRequired,
  onConfirm: func,
  onCancel: func,
  dataId: string,
};

export default CEEUnavailableModal;
